import { render, staticRenderFns } from "./VerifyResetPassword.vue?vue&type=template&id=427b545e&scoped=true"
import script from "./VerifyResetPassword.vue?vue&type=script&lang=js"
export * from "./VerifyResetPassword.vue?vue&type=script&lang=js"
import style0 from "./VerifyResetPassword.vue?vue&type=style&index=0&id=427b545e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427b545e",
  null
  
)

export default component.exports